import { Pipe, PipeTransform, inject } from '@angular/core';
import { ScoringDefinitionService } from '../scoring-definition.service';
import { Observable, combineLatest, map, of, switchMap } from 'rxjs';
import { ObjectType } from '@galaxy/crm/static';
import { isAcceptedObjectType } from '../../validators';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fieldName',
  standalone: false,
})
export class FieldNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly scoringDefinitionService = inject(ScoringDefinitionService);

  transform(filterId?: string, objectType?: ObjectType): Observable<string> {
    if (!filterId) {
      return of('');
    }
    if (!isAcceptedObjectType(objectType)) {
      return of('');
    }
    const filterOverride$ = this.scoringDefinitionService.getFilterOverride(filterId, objectType);
    const fieldName$ = this.scoringDefinitionService.getFieldSchema$(objectType).pipe(
      map((fieldSchema) => fieldSchema?.find((fs) => fs.fieldId === filterId)),
      map((fs) => fs?.fieldName ?? filterId),
    );
    return combineLatest([fieldName$, filterOverride$]).pipe(
      map(([fieldName, filterOverride]) => filterOverride?.title ?? fieldName),
      switchMap((fieldName) => this.translateService.stream(fieldName)),
    );
  }
}
